export default __webpack_public_path__ + "static/media/330_store03-fr-web.e252bd30.png";